import { useRouter } from "next/router";

import BaseBottomSheet from "@domains/common/views/modal/BaseBottomSheet/BaseBottomSheet";
import useModalState from "@logics/hooks/useModalState";
import { Typo } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import WebViewBridge from "@logics/utils/webViewBridge";
import ProjectMemberViewModel from "@domains/project/viewModel/ProjectMemberViewModel";
import { dataTrackEvent } from "@logics/utils/dataTrackEvent";
import { DATA_TRACKING_EVENT_NAME } from "@domains/common/constants/dataTrackEventName";

import * as S from "./AvatarListBottomSheet.style";

interface AvatarListBottomSheetProps {
  memberList: ProjectMemberViewModel[];
}

const AvatarListBottomSheet = ({ memberList }: AvatarListBottomSheetProps) => {
  const { push } = useRouter();

  const { closeModal } = useModalState();

  const moveToUserProfilePage = (participantId: number) => {
    dataTrackEvent({
      eventName: DATA_TRACKING_EVENT_NAME.PROJECT_DETAIL.CLICK_MEMBER_PROFILE,
      properties: memberList.find(({ userId }) => userId === participantId),
    });

    if (WebViewBridge.isInAppWebView()) {
      WebViewBridge.getInstance().navigateToUserProfile(participantId);
    } else {
      push({
        pathname: `${NAVIGATION_ROUTE.PROFILE.HREF}/${participantId}`,
        query: NAVIGATION_ROUTE.PROFILE.QUERY,
      });
    }
  };

  return (
    <BaseBottomSheet
      headerTitle={`${memberList?.length} Member${memberList?.length > 1 ? "s" : ""}`}
      closeBtnType="icon"
      setting={{
        $roundBorder: true,
        $noPadding: true,
      }}
      onClose={closeModal}
    >
      <S.Container>
        {memberList?.map((member) => (
          <S.MemberContainer
            key={member.userId}
            $isClickable
            onClick={() => moveToUserProfilePage(Number(member.userId))}
          >
            <S.ImageContainer>
              <S.AvatarImageWrapper>
                <S.MemberAvatar
                  src={member.profileImage || "/assets/image_default9.png"}
                  alt="member profile"
                  width={0}
                  height={0}
                  sizes={`${S.AVATAR_SIZE}px`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </S.AvatarImageWrapper>
            </S.ImageContainer>
            <S.MemberInfoWrap>
              <Typo.Text name="strongM" color={grayScale.white}>
                {member.name}
              </Typo.Text>
              <Typo.Text name="s" color={grayScale[500]}>
                {member.nationalWithFlag}
              </Typo.Text>
            </S.MemberInfoWrap>
          </S.MemberContainer>
        ))}
      </S.Container>
    </BaseBottomSheet>
  );
};

export default AvatarListBottomSheet;
